import { render, staticRenderFns } from "./CocAssetsEmpty.vue?vue&type=template&id=a9ac6a54&scoped=true"
import script from "./CocAssetsEmpty.vue?vue&type=script&lang=js"
export * from "./CocAssetsEmpty.vue?vue&type=script&lang=js"
import style0 from "./CocAssetsEmpty.vue?vue&type=style&index=0&id=a9ac6a54&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_qfdn4gbztslujeagaknuyibsmy/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9ac6a54",
  null
  
)

export default component.exports